module.exports = __webpack_public_path__ + "img/icon-earth.bd2e80c3.png";